import { createWidgetMixin } from 'vue-instantsearch';
import { connectSearchBox } from 'instantsearch.js/es/connectors';

export default {
  name: 'virtual-search-box',
  mixins: [createWidgetMixin({ connector: connectSearchBox })],
  render() {
    return null;
  },
};
